// removed by extract-text-webpack-plugin
module.exports = {"tracking-step":"tracking-step","subtitle":"subtitle","options":"options","option":"option","option-text":"option-text","selected":"selected","btn-primary":"btn-primary","icon":"icon"};


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/conversion-quiz/steps/tracking/tracking.style.sass
// module id = sk85
// module chunks = 1